module.exports = require("react-joyride");